<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row custom-body">
        <div v-if="isSending" class="custom-sending">
          <i class="fas fa-spinner fa-spin"></i
          ><span class="ms-2">Sending Message...</span>
        </div>
        <email-message
          v-show="!isSending"
          :view="show"
          ref="emailMessage"
          @edited="edited"
          @valid="valid"
        />
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6">
          <z-message
            v-model="message"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              v-show="isEdited"
              class="btn btn-primary me-2"
              :disabled="!messageValid || isSending"
              @click="send"
            >
              <i class="fas fa-envelope"></i><span class="ms-2">Send</span>
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EmailMessage from '@/Components/UserCardio/elements/email-message'
import ZDialog from '@/Components/ZElements/Dialog.vue'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'send-message',
  components: {
    ZDialog,
    EmailMessage,
    ZMessage,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      messageValid: false,
      isSending: false,
      message: null,
      isEdited: false,
    }
  },
  mounted() {
    this.isSending = false
    this.messageValid = false
    this.message = null
    this.isEdited = false
  },
  emits: ['close', 'saved'],
  computed: {
    ...mapGetters('usercardio', ['columns', 'lists', 'memberids']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Compose Message'
      return _title
    },
    orgId() {
      let _data = null
      if (this.show) {
        _data = this.show.orgid
      }
      return _data
    },
    id() {
      let _data = null
      if (this.show) {
        _data = this.show.id
      }
      return _data
    },
    type() {
      let _data = null
      if (this.show) {
        _data = this.show.type
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', ['setCustomView']),
    ...mapActions('messages', ['saveMessage']),
    close() {
      this.isEdited = false
      this.$emit('close')
    },
    edited(value) {
      this.isEdited = value
    },
    valid(value) {
      this.message = null
      this.messageValid = value.isValid
      if (!value.isValid) {
        // this.message = value.whatsNot
      }
    },
    test() {
      this.isSending = !this.isSending
    },
    async send() {
      this.isSending = true
      let data = await this.$refs.emailMessage.getMessageData()
      if (data) {
        console.log('Sending Message', data)
        let results = await this.saveMessage(data)
        console.log('Message Sent', results)
        this.isSending = false
        this.isEdited = false
        if (results !== 'Success') {
          alert(`Message Failed: ${results}`)
        } else {
          alert('Message Sent')
          this.$emit('close')
        }
      }
    },
  },
}
</script>
<style scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-sending {
  position: relative;
  height: 500px;
}
</style>
